/**
 * Created by kmiltiadous on 20/07/2017.
 */
import {HttpService} from './http.service';
import {Injectable, InjectionToken} from '@angular/core';
import {URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {ITravelCreditService} from './travel-credit.interface';
import {TravelCredit} from '../models/travel-credit';
import {AuditableTransactionId} from '../models/auditable-transaction-id';
import {ReasonCode} from '../models/reason-code';
import {RefundReason} from '../models/refund-reason';
import {Currency} from '../models/currency';
import {TravelCreditType} from '../models/travel-credit-type';
import {Team} from '../models/team';
import {AuditableTravelCredits} from '../models/auditable-travel-credits';
import {AuditableTravelCreditBatch} from '../models/auditable-travel-credit-batch';
import {AuditableTravelCredit} from '../models/auditable-travel-credit';
import {Reservation} from '../models/reservation';
import {Credit} from '../models/credit';
import {GuestCredit} from '../models/guest-credit';
import {NotificationResult} from '../models/notification-result';
import {AuditableBaseResult} from '../models/auditable-base-result';
import {Iata} from '../models/iata';
import {Agency} from '../models/agency';
import {Partner} from "../models/partner";

export const TRAVEL_CREDIT_SERVICE_TOKEN = new InjectionToken<ITravelCreditService>('travel-credit.service');

@Injectable()
export class TravelCreditService implements ITravelCreditService {

  constructor(private http: HttpService){
  }

  createTravelCredits(reservation: any, credit: any, guestCredits: any, agency: any, iata: any): Observable<AuditableTransactionId> {
    const travelCredits: Array<TravelCredit> = new Array<TravelCredit>();
    for (const guest of guestCredits) {
      const travelCredit = TravelCredit.createFrom(reservation, credit, guest, agency, iata);
      travelCredits.push(travelCredit);
    }
    return this.http.sendPostRequest('travelcredits', TravelCredit.parseCreateTravelCreditJson(travelCredits),
      AuditableTransactionId.parseCreateTravelCreditTransactionResponse);
  }

  getReasonCodes(): Observable<Array<ReasonCode>> {
    return this.http.sendGetRequest('lookup/reasoncodes', ReasonCode.parseReasonCodesResponse);
  }

  getRefundReasons(): Observable<Array<RefundReason>> {
    return this.http.sendGetRequest('lookup/refundreasons', RefundReason.parseRefundReasonsResponse);
  }

  getCurrencies(): Observable<Array<Currency>> {
    return this.http.sendGetRequest('lookup/currencies', Currency.parseCurrenciesResponse);
  }

  getTravelCreditTypes(): Observable<Array<TravelCreditType>> {
    return this.http.sendGetRequest('lookup/travelcredittypes', TravelCreditType.parseTravelCreditTypesResponse);
  }

  getTeams(): Observable<Array<Team>> {
    return this.http.sendGetRequest('lookup/teams', Team.parseTeamsResponse);
  }

  getTransaction(transactionId: string): Observable<AuditableTravelCredits> {
    return this.http.sendGetRequest('travelcredits/transactions/' + transactionId, TravelCredit.parseTravelCreditsResponse);
  }

  getTravelCredit(id: number): Observable<AuditableTravelCredit> {
    return this.http.sendGetRequest('travelcredits/' + id, TravelCredit.parseTravelCreditResponse);
  }

  getAllTravelCredits(itemsPerPage): Observable<AuditableTravelCreditBatch> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('itemsPerPage', itemsPerPage);

    return this.http.sendGetRequest('travelcredits', TravelCredit.parseTravelCreditBatchResponse, params);
  }

  getTravelCredits(pnr, createdDateFrom, createdDateTo, firstItemNumber, itemsPerPage): Observable<AuditableTravelCreditBatch> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('pnr', pnr);
    params.set('createdDateFrom', createdDateFrom);
    params.set('createdDateTo', createdDateTo);
    params.set('firstItemNumber', firstItemNumber);
    params.set('itemsPerPage', itemsPerPage);

    return this.http.sendGetRequest('travelcredits', TravelCredit.parseTravelCreditBatchResponse, params);
  }

  updateTravelCredit(id: number, reservation: Reservation, credit: Credit, guestCredit: GuestCredit, agency: Agency, iata: Iata): Observable<AuditableTravelCredit> {
    const travelCredit = TravelCredit.createFrom(reservation, credit, guestCredit, agency, iata, id);
    return this.http.sendPutRequest(`travelcredits/${id}`, TravelCredit.parseUpdateTravelCreditJson(travelCredit),
      TravelCredit.parseTravelCreditResponse);
  }

  getPartners(): Observable<Array<Partner>> {
    return this.http.sendGetRequest('lookup/partners', Partner.parsePartnersResponse);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/travel-credit.service.ts